/** Mirrors the backend rule: "*" grants all, "module:*" grants a module, else exact match. */
export function can(granted: string[], needed: string): boolean {
  const module = needed.split(":", 1)[0];
  return granted.includes("*") || granted.includes(needed) || granted.includes(`${module}:*`);
}
